module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/CircleSolid.65d09796.svg";